import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import { teamData } from 'data/team';

const Team = ({ activeIndex, num }: any) => {

  return (
    <div className="bg-white py-12 w-full">
      {
        teamData.map((item, idx) => (
          <div className='container' key={idx}>
            <div className='flex flex-col items-center gap-4 pt-[79px]'>
              <div>
                <div className='flex flex-col mb-6'>
                  <motion.p
                    className='font-bold text-60 text-black tablet:text-2xl leading-none'
                    transition={{ delay: 0.1 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    {item.team}
                  </motion.p>

                  <motion.p
                    className='font-medium text-[#E7E7E7] text-60 tablet:text-2xl leading-none'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    {item.teamEn}
                  </motion.p>
                </div>

                <div className="flex flex-col gap-3 mb-10">
                  {
                    item.intro.map((item, idx) => (
                      <div className='flex items-baseline gap-2' key={idx}>
                        <motion.div
                          className='bg-[#9655FF] w-2 h-2 shrink-0'
                          transition={{ delay: 0.2 + 0.1 * idx }}
                          initial={START_ANIMATION_PROPERTY}
                          whileInView={END_ANIMATION_PROPERTY}
                          viewport={VIEWPORT_PROPERTY}>
                        </motion.div>
                        <motion.div
                          className='font-semibold text-black text-xs'
                          transition={{ delay: 0.2 + 0.1 * idx }}
                          initial={START_ANIMATION_PROPERTY}
                          whileInView={END_ANIMATION_PROPERTY}
                          viewport={VIEWPORT_PROPERTY}
                        >
                          {item.title} : <span className='font-medium'>{item.content}</span>
                        </motion.div>
                      </div>
                    ))
                  }
                </div>
              </div>

              <motion.img
                src={item.imgMo}
                alt="팀이미지"
                initial={START_ANIMATION_PROPERTY}
                whileInView={END_ANIMATION_PROPERTY}
                viewport={VIEWPORT_PROPERTY} >
              </motion.img>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default Team
